function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "RSS"
}, /*#__PURE__*/React.createElement("path", {
  d: "M163 283.5h-28.3c0-42.1-13-74.6-38.7-96.7C72.6 166.6 39.4 156 0 156v-28.3c46.3 0 85.9 13 114.5 37.7 31.7 27.2 48.5 68.1 48.5 118.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M248 283.5h-28.3c0-35.9-5.8-68.2-17.3-95.9-10.7-25.7-26.3-47.7-46.4-65.4C117.8 88.6 63.9 70.9 0 70.9V42.5c70.8 0 131.3 20.2 174.7 58.3 23.4 20.6 41.5 46.1 53.9 75.9 12.9 31.2 19.4 67.1 19.4 106.8z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "39",
  cy: "248",
  rx: "39",
  ry: "35.4"
}))));